import React from 'react';
import { AppModule } from './components/AppModule';
import { bootstrap } from 'mini-bootstrap';
import { getAppNameForModule } from './utils/getAppNameForModule';
import { getServiceWorkerConfig } from './utils/getServiceWorkerConfig';
import { initializeModule } from './utils/initializeModule';
import { type Module } from 'mini-common-schema';
import { registerA2HSEventListeners } from 'mini-a2hs';
import { registerBootstrapOptions } from './optionsRegistry';
import { setApp } from 'owa-config/lib/bootstrapOptions';
import { setupExceptionHandler } from 'mini-exception-handler';
import type { BootstrapOptions } from 'mini-bootstrap';

/**
 * Bootstrap the mini app module
 */
export async function appBootstrap(options: BootstrapOptions) {
    // Execute as early to catch unhandled errors
    setupExceptionHandler();

    const { appModuleProps } = options;

    // we will default to mail module
    const currentModule = appModuleProps.module || 0;
    const appName = getAppNameForModule(currentModule);

    // Register as soon as possible to listen to the browser events and prevent the default behavior
    registerA2HSEventListeners(appName);

    setApp(appName);
    initializeModule(currentModule);
    registerBootstrapOptions(options);

    const updatedBootstrapOptions: BootstrapOptions = {
        ...options,
        swConfig: getServiceWorkerConfig(),
        renderMainComponent: () => <AppModule />,
    };

    return bootstrap(updatedBootstrapOptions);
}
